import { render, staticRenderFns } from "./ReleaseNotesEdit.vue?vue&type=template&id=13936ca4"
import script from "./ReleaseNotesEdit.vue?vue&type=script&lang=ts"
export * from "./ReleaseNotesEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports